
import UserTick from "../../../assets/duotone/UserTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function UserTickIcon({ className, dataTestid = "UserTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <UserTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
